<app-product-details-slider
    [images]="product.productImages"
    [discount]="discount"
    [showMainImage]="showMainImage"
    [slidesPerView]="slidesPerView"
    [spacing]="0"
    [showDots]="showDots"
    [showNav]="showNav">
</app-product-details-slider>
